export const getDateNum = () => {
	// if (typeof window == 'undefined') {
	// 	return;
	// }
	// const queryString = window.location.search;
	// const params = new URLSearchParams(queryString);
	// const data = params.get('dateNum');

	const data = '4'; //CHANGE DATE NUM HERE 
	return data;
};

export const getRiggedSlotMachine = () => {
	if (typeof window == 'undefined') {
		return;
	}
	const queryString = window.location.search;
	const params = new URLSearchParams(queryString);
	if (__IS_LOCAL__ || __IS_DEMO__) {
		return params.get('rigSlotMachine');
	}
	return false;
};